<template>
  <div class="routeTab">
    <router-link :to="{ name: 'fapiao.issue_houpiao.list' }">加油单开发票</router-link>
    <router-link :to="{ name: 'fapiao.charge.list' }">充电/占位费订单开发票</router-link>
    <router-link :to="{ name: 'fapiao.issue_discount.list' }">折扣卡开发票</router-link>
    <router-link :to="{ name: 'fapiao.houpiao.list' }">发票记录</router-link>
    <router-link :to="{ name: 'fapiao.prepaidCard_invoice.list' }">预付卡开发票</router-link>
    <router-link :to="{ name: 'fapiao.employee_upload.list' }">已上传发票</router-link>
    <router-link :to="{ name: 'fapiao.service_fee_invoice.list' }">服务费开发票</router-link>
  </div>
</template>

<style>
.routeTab {
  font-weight: 500;
}
</style>
